<div *ngIf=" websiteName == 'Major'" class="main-container">
    <div class="amazon-container">
        <div class="left-content">
            <div>
                <div class="bottom-static-content" style="width: 100% !important;">
                    <img class="title-header" src="{{staticTitleContent?.[0].mediaUrl}}" /><br>
                    <p  style="width: 100% ; " [innerHTML]="staticTitleContent?.[0].description">
                    </p>
                </div>
            </div> 
            <h2 style="font-weight: bold !important;" class="show-content" [innerHTML]="staticVideoContent?.[0].description"></h2>
            <div *ngIf="staticVideoContent?.length">
                <img alt="Video" class="video-placeholder" src="{{staticVideoContent?.[0].mediaUrl}}" />
            </div>
            <button  *ngIf="staticVideoContent?.length" class="watch-button" [ngStyle]="{'width':isMobileDevice()?'100%':''}"
                (click)="  openAlertDialog(staticVideoContent?.[0].targetlink)">{{staticVideoContent?.[0].Button}}
                <img src="../../../../assets/images/Major/Arrow_right_btn_icon.png" />
            </button>
        </div>
        <div  *ngIf="(isDesktopDevice() || isTabletDevice() ) && staticTitleContent?.length" >
            <img src="{{staticTitleContent?.[1].mediaUrl}}" style="margin-left: 5%;"  class="image-placeholder" alt="People Running" />
            <p  style="width: 100% ; font-size: smaller !important; text-align: right;margin-left: 18px; " [innerHTML]="staticTitleContent?.[1].description"></p>
        </div>
    </div>
    <div [ngClass] ="{'btm-padding-mobile':isMobileDevice()}" >
    <div [ngClass] ="{'btm-padding':isMobileDevice()}" >
        <br>
        <div >
            <h1 style="text-align: center;" [ngStyle]="{'width':isMobileDevice()?'100%':''}" class="title-btm"
                [innerHTML]="callToActionMajor?.[0]?.title"></h1>
        </div>
        <div class="cta-majorimage-container">
            <div  class="cta-inner-container">
                <div *ngFor="let cta of callToActionMajor| slice:1; let i = index"
                   class="cta-major-box" >
                   <div>
                       <img   [ngClass]="{'img-placeholder' : !cta.mediaUrl , 'mat-card-img': cta.mediaUrl}"  src="{{cta.mediaUrl}}" 
                       />   
                   </div>
                   <div *ngIf="isDesktopDevice()"><br></div>
                    <mat-card-content>
                        <p class="descContent" [innerHTML]="cta.description"></p>
                        <mat-card-actions class="center-actions">
                        <button  style="border-radius: 6px;"
                            (click)="navigateToTargetLink(cta)" color="accent" mat-raised-button  [ngStyle]="{'font-size':isMobileDevice()?'12px':''}">{{cta.Button}}
                            <img alt="Image" src="../../../../assets/images/Major/Arrow_right_btn_icon.png" />
                        </button>
                        </mat-card-actions>
                    </mat-card-content>
                    <br>
                </div>
            </div>
        </div>
    </div>
</div>
</div>